module.exports = __webpack_public_path__ + "media/newstyle/images/close-b044cf36438444f13b95da4e53d09d3b.svg";